<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                ]"
            />
        </template>

        <AlertMessage class="inline-block">
            <template v-slot:title>
                {{ $t('messages.information') }}
            </template>
            <template v-slot:body> {{ timeslot.message }} </template>
        </AlertMessage>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AlertMessage from '@/components/AlertMessage.vue';

export default {
    components: {
        AlertMessage,
        PanelPage,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'trades', 'timeslot'],
    data() {
        return {
            form: this.$inertia.form({}),
        };
    },
    methods: {},
};
</script>
